export default "__VITE_ASSET__DpBuaH_n__"